export { BackgroundImage }

/** @public */
export type ImageFit = "fill" | "fit" | "stretch"

/** @public */
interface BackgroundImage {
    src: string
    pixelWidth?: number
    pixelHeight?: number
    intrinsicWidth?: number
    intrinsicHeight?: number
    fit?: ImageFit
}

const key: keyof BackgroundImage = "src"

/** @public */
namespace BackgroundImage {
    export const isImageObject = function(image: any): image is object & BackgroundImage {
        if (!image || typeof image === "string") return false
        return key in image
    }
}
